import { useTranslation } from 'react-i18next';
import { Sheet, SheetHeader, SheetTitle, SheetBody, SheetActions } from './ui/Sheet';
import { Button } from './ui/Button';
import './RefundSheet.css';

interface RefundSheetProps {
  open: boolean;
  onClose: () => void;
  amount?: number | null;
}

export function RefundSheet({ open, onClose, amount }: RefundSheetProps) {
  const { t } = useTranslation();

  const supportEmail = 'support@olso.app';

  return (
    <Sheet open={open} onClose={onClose}>
      <SheetHeader>
        <div className="rfs-icon" aria-hidden="true">
          {/* Amber circle with banknote icon */}
          <div className="rfs-icon-circle">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2" y="6" width="20" height="12" rx="2" />
              <circle cx="12" cy="12" r="2" />
              <path d="M6 12h.01M18 12h.01" />
            </svg>
          </div>
        </div>
        <SheetTitle>{t('orderType.refundTitle')}</SheetTitle>
      </SheetHeader>
      <SheetBody>
        <p className="rfs-body">{t('orderType.refundBody')}</p>
        {amount != null && amount > 0 && (
          <p className="rfs-amount">{amount.toLocaleString()} ₸</p>
        )}
      </SheetBody>
      <SheetActions>
        <Button variant="primary" size="lg" onClick={onClose}>
          {t('orderType.refundCta')}
        </Button>
        <a
          className="rfs-support-link"
          href={`mailto:${supportEmail}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('orderType.refundSupport')}
        </a>
      </SheetActions>
    </Sheet>
  );
}
